<script lang="ts" setup>
import { LocalizedNewsItem, NewsItem } from '@/helper/Types'
import { computed } from 'vue'
import { formatDate } from '@/helper/filter'
import UserStore from '@/store/UserStore'

const props = defineProps<{
  item: NewsItem
}>()

const newsItem = computed((): LocalizedNewsItem | undefined => {
  return props.item.localizedNews.find(item => item.language === UserStore.currentLanguage)
})
</script>

<template>
  <div v-if="newsItem" class="fTable__tr has--td">
    <div class="fTable__td column">
      <span>{{ newsItem?.text }}</span>
    </div>

    <div class="fTable__td column date">
      <span>{{ formatDate(new Date(item.createdAt)) }}</span>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@/assets/style/helpers/include-media';

.column {
  &.date {
    justify-content: flex-end;

    span {
      font-size: rem-calc(16);
      color: $textColorLight;
    }
  }

  &:not(:first-child) {
    align-items: flex-start;

    @include media('>=tablet') {
      flex-basis: 20%;
    }
  }

  span {
    &:not(.text-ellipsis) {
      white-space: pre-line;
    }
  }
}
</style>
